import { ADDRESS_RIGHT, sendRequest } from "utility";

export const addressRightGetAutoComplete = async ({ term = "" }) => {
  return await sendRequest(
    `${ADDRESS_RIGHT.BASE_URL}/autocomplete.json?api_key=${ADDRESS_RIGHT.API_KEY}&term=${term}`
  );
};

export const addressDetailInfo = async (addressId = "") => {
  if (!Boolean(addressId)) return {};
  return await sendRequest(
    `${ADDRESS_RIGHT.BASE_URL}/address.json?api_key=${ADDRESS_RIGHT.API_KEY}&id=${addressId}`
  );
};
